import React, { useEffect, useState } from "react";
import userImg from "../../../assets/images/admin.png";
const Review = ({ res }) => {
  const [averageRating, setaverageRating] = useState(0);
  const [detailedRating, setDetailedRating] = useState([{}]);
  useEffect(() => {
    const totalUser = res?.ratingData;
    const sumRating = res?.ratingData?.reduce((acc, rating) => {
      return rating?.startCount ? acc + rating?.startCount : acc;
    }, 0);
    const obj = {};

    const average = sumRating / totalUser?.length || 0;

    setaverageRating(Math.round(average));
    if (totalUser?.length > 0) {
      res?.ratingData?.forEach((rating, i, data) => {
        if (rating?.startCount in obj) {
          obj[rating?.startCount]++;
        } else {
          obj[rating?.startCount] = 1;
        }
        const star = [
          ...new Set(data.map((result) => result?.startCount || 0)),
        ];

        const fullDetailRating = star.map((str) => ({
          precentage: (obj[str] / data.length) * 100 || 0,
          star: str,
        }));
        setDetailedRating(fullDetailRating);
      });
    } else {
      setDetailedRating([]); // If no ratings, set an empty array (or object as needed)
    }
  }, [res]);

  return (
    <div className="tab-pane fade active show" id="Review">
      <div className="LiveStreamAreaArea w-100">
        <div className="AverageReviewBox">
          <h4>Average Review</h4>
          <aside>
            <h5>{averageRating}</h5>

            <div className="Ratings">
              {Array.from({ length: 5 }, (_, index) => {
                return (
                  <span key={index}>
                    <i
                      className={
                        index < averageRating
                          ? "fa-solid fa-star checked"
                          : "fa-regular fa-star"
                      }
                    />
                  </span>
                );
              })}
            </div>

            <p>Rating</p>
          </aside>
        </div>
        <div className="ProgressBarArea Width">
          <h4>Detailed Rating</h4>
          <ul>
            {detailedRating.length > 0 ? (
              detailedRating?.map((detailRat, i) => {
                return (
                  <li key={i}>
                    <label>{detailRat?.precentage?.toFixed(2) || 0}%</label>
                    <div className="Ratings d-flex">
                      {Array.from({ length: 5 }, (_, index) => (
                        <span key={index}>
                          <i
                            className={
                              index < detailRat?.star
                                ? "fa-solid fa-star checked"
                                : "fa-regular fa-star"
                            }
                          />
                        </span>
                      ))}
                    </div>
                    <div className="ProgressBar">
                      <span
                        className="Progress"
                        style={{
                          width: `${detailRat?.precentage?.toFixed(2) || 0}%`,
                        }}
                      />
                    </div>
                  </li>
                );
              })
            ) : (
              <li>
                <label>{0}%</label>
                <div className="Ratings d-flex">
                  {Array.from({ length: 5 }, (_, index) => (
                    <span key={index}>
                      <i className="fa-regular fa-star" />
                    </span>
                  ))}
                </div>
                <div className="ProgressBar">
                  <span
                    className="Progress"
                    style={{
                      width: `0%`,
                    }}
                  />
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div style={{ clear: "both" }} />
      <div className="RatingComment">
        {res?.ratingData?.map((data, i) => {
          return (
            <article key={i}>
              <aside>
                <figure>
                  <img src={data?.user?.profilePic || userImg} />
                </figure>
                <figcaption>
                  <h6>{data?.user?.fullName}</h6>
                  <div className="Ratings">
                    {Array.from({ length: 5 }, (_, index) => (
                      <span key={index}>
                        <i
                          className={
                            index < data?.startCount
                              ? "fa-solid fa-star"
                              : "fa-regular fa-star"
                          }
                        />
                      </span>
                    ))}
                  </div>
                </figcaption>
              </aside>
              <p>{data?.comment}</p>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default Review;
